import { promocodeField } from './fields/promocode.field';

export const discountConditionsPolicies = {
    promocode: promocodeField,
};
